export var ButtonActionKind;
(function (ButtonActionKind) {
    ButtonActionKind["ApplyPromoCode"] = "apply_promo_code";
    ButtonActionKind["OpenUrl"] = "open_url";
    ButtonActionKind["OpenMailClient"] = "open_mail_client";
    ButtonActionKind["CallPhoneNumber"] = "call_phone_number";
    ButtonActionKind["CloseTool"] = "close_tool";
    ButtonActionKind["EmailCapture"] = "email_capture";
    ButtonActionKind["SavedSearch"] = "saved_search";
    ButtonActionKind["GoMainStep"] = "go_main_step";
    ButtonActionKind["SendForm"] = "form";
    ButtonActionKind["OpenBookingEngine"] = "send_to_be";
    ButtonActionKind["Submit"] = "submit";
    ButtonActionKind["LastSearch"] = "send_to_last_search";
})(ButtonActionKind || (ButtonActionKind = {}));
export var DiscountCodeKind;
(function (DiscountCodeKind) {
    DiscountCodeKind["Default"] = "default";
    DiscountCodeKind["Coupon"] = "coupon";
    DiscountCodeKind["Rate"] = "rate";
    DiscountCodeKind["Corporative"] = "corpo";
    DiscountCodeKind["Group"] = "group";
})(DiscountCodeKind || (DiscountCodeKind = {}));
export var ButtonKind;
(function (ButtonKind) {
    ButtonKind["Primary"] = "primary";
    ButtonKind["Secondary"] = "secondary";
})(ButtonKind || (ButtonKind = {}));
//# sourceMappingURL=button.types.js.map